<template>
  <span ref="autot">
    <v-data-table
      :headers="stablecolumns"
      :items="rowswithid"
      class="autotable"
      :items-per-page-options="rowsperpageitems"
      :hide-default-footer="disablePagination"
      v-if="dynarefresh"
    >
      <template slot="item" slot-scope="row">
        <tr>
          <td v-if="selectable" class="rowselect" @click="selectrow(row)">
            <v-icon v-if="isrowselected(row)">mdi-arrow-right-bold-circle</v-icon>
            <v-icon v-else>mdi-arrow-right-bold-circle-outline</v-icon>
          </td>
          <td
            v-for="col in tablecolumns"
            v-bind:key="col.value"
            :style="col.width ? `width:${col.width}%` : undefined"
            :class="`${col.tdclass} ${col.readonly ? 'readonly' : ''}`"
            @click="startEdit(row,col)"
          >
            <component
              :is="ctype(col.inputtype)"
              :maxlength="col.maxlength"
              :required="col.required"
              :text="lget(row.item, col.value)"
              :tooltip="lget(row.item, col.tooltip)"
              :items="col.values"
              :email="col.email"
              :password="col.password"
              :decimals="col.decimals"
              @change="_change(row, col, ...arguments)"
              @blur="_blur()"
              :cellid="cellid(row,col)"
              :editingcell="editing"
              :readonly="readonly || col.readonly"
              :translate="col.translate"
            ></component>
          </td>
          <td v-if="!readonly && deletable" class="rowdelete">
            <tt-button @clicked="deleteRow(row.item)" icon="delete" text="common.delete"></tt-button>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div
      :class="`table-footer-prepend${disablePagination || disablePagination === '' ? 'solo' : ''} d-flex pl-2 align-center`"
    >
      <v-dialog v-if="!readonly" v-model="openDialog" max-width="500px">
        <template v-slot:activator="{ }">
          <v-btn
            :class="disablePagination || disablePagination === '' ? 'addbuttonsolo' : ''"
            fab
            dark
            small
            @click="newRow"
            color="primary"
          >
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="pb-2">
            <h3 class="primary--text">{{ $t(dialogtitle) }}</h3>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md class="py-0">
              <v-form v-model="valid" @submit.prevent>
                <v-layout wrap>
                  <v-flex
                    v-for="col in createcolumns"
                    v-bind:key="col.value"
                    :class="col.inputtype != 'SVG' ? 'xs12 sm6 md4' : 'xs12 sm6 md8'"
                  >
                    <component
                      v-if="openDialog"
                      :is="ctype(col.inputtype)"
                      :maxlength="col.maxlength"
                      :required="col.required"
                      :items="col.values"
                      :email="col.email"
                      :password="col.password"
                      :label="col.text"
                      :text="lget(newrow, col.value)"
                      @change="_changeNewRow(col, ...arguments)"
                      :autofocus="createcolumns[0] == col"
                    ></component>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dismissDialog">{{ $t('common.cancel') }}</v-btn>
            <v-btn
              :disabled="!valid"
              color="blue darken-1"
              text
              @click="saveNewRow"
            >{{ $t('common.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        v-if="excellink"
        dark
        fab
        small
        :href="exportExcel()"
        @click="mShowInfoMessage('Excel export requested')"
        color="primary"
        class="ml-3"
        :loading="xlsdownloading"
      >
        <v-icon dark>mdi-file-excel</v-icon>
      </v-btn>
    </div>
  </span>
</template>

<script>
import TextInput from "./TextInput.vue";
import FormulaInput from "./FormulaInput.vue";
import LookupInput from "./LookupInput.vue";
import CheckboxInput from "./CheckboxInput.vue";
import DateInput from "./DateInput.vue";
import IconInput from "./IconInput.vue";
import SVGInput from "./SVGInput.vue";
import FloatInput from "./FloatInput.vue";
import ColourInput from "./ColourInput.vue";
import IntegerInput from "./IntegerInput.vue";
import { isEmpty, cloneDeep, get, set, concat } from "lodash";
import { mapMutations } from "vuex";
import Vue from "vue";
import moment from "moment";

export default {
  props: [
    "keyfield",
    "columns",
    "rows",
    "excellink",
    "dialogtitle",
    "rowsperpage",
    "selectable",
    "delete",
    "readonly",
    "disable-pagination"
  ],
  components: {
    textinput: TextInput,
    formulainput: FormulaInput,
    lookupinput: LookupInput,
    checkboxinput: CheckboxInput
  },
  data() {
    return {
      openDialog: false,
      editing: undefined,
      newrow: {},
      valid: "",
      xlsdownloading: false,
      selectedrow: undefined,
      dynarefresh: true
    };
  },
  computed: {
    deletable() {
      return !isEmpty(this.delete);
    },
    tablecolumns() {
      return this.columns.filter(col => !col.insertonly);
    },
    stablecolumns() {
      var filtered = this.tablecolumns;
      if (this.selectable) {
        filtered = concat({ text: "", value: "", sortable: false }, filtered);
      }
      if (!this.readonly && this.deletable) {
        filtered = concat(filtered, { text: "", value: "", sortable: false });
      }
      return filtered;
    },
    createcolumns() {
      return this.columns.filter(
        col => col.inputtype !== "FORMULA" && !col.noinsert
      );
    },
    rowsperpageitems() {
      return this.rowsperpage
        ? this.rowsperpage
        : [
            5,
            10,
            25,
            { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
          ];
    },
    rowswithid() {
      if (this.keyfield)
        // if you are stupid enough to specify a keyfied, and let it undefined in the objects, well, you deserve to debug undefinitely ...
        return this.rows;
      return this.rows.map((row, index) => {
        if (row.id) return row;
        let rowwid = cloneDeep(row);
        rowwid.id = index;
        return rowwid;
      });
    }
  },
  methods: {
    ...mapMutations(["mShowInfoMessage"]),
    lget(object, path) {
      return get(object, path);
    },
    exportExcel() {
      if (this.excellink) return Vue.$href(this.excellink);
      return undefined;
    },
    _changeNewRow(col, text) {
      this.$log.debug("_changeNewRow", col, text);
      set(this.newrow, col.value, text);
      this.$log.debug("_changeNewRow: new row now:", this.newrow);
    },
    startEdit(row, col) {
      let newcellid = this.cellid(row, col);
      if (newcellid == this.editing) return;
      this.editing = undefined;
      this.$log.debug(
        "start editing cellid: ",
        this.keyfield,
        row,
        col,
        this.cellid(row, col)
      );
      this.$nextTick(() => (this.editing = this.cellid(row, col)));
    },
    rowitemkey(row) {
      return row.item[this.keyfield ? this.keyfield : "id"];
    },
    cellid(row, col) {
      return `${this.rowitemkey(row)}-${col.value}`;
    },
    selectrow(row) {
      let srow = this.rowitemkey(row);
      if (this.selectedrow === srow) {
        this.selectedrow = undefined;
        this.$emit("rowselected", undefined);
      } else {
        this.selectedrow = srow;
        this.$emit("rowselected", row.item);
      }
    },
    isrowselected(row) {
      let srow = this.rowitemkey(row);
      return this.selectedrow === srow;
    },
    async deleteRow(row) {
      this.$log.debug("DELETE ROW REQUESTED: ", row);
      let res = await this.$confirm(
        this.$i18n.t(this.delete.text, this.delete.fun(row)),
        {
          title: this.$i18n.t(this.delete.title)
        }
      );
      if (res) {
        this.$emit("delete", row);
      }
    },
    newRow() {
      for (let col of this.columns) {
        let val = "";
        if (col.inputtype == "CHECKBOX") val = false;
        if (col.inputtype == "DATE")
          val = moment(new Date()).format("yyyy-DD-MM");
        if (col.inputtype == "COLOUR") val = "#556689";
        //this.$set(this.newrow, col.value, val);
        set(this.newrow, col.value, val);
      }
      this.openDialog = true;
    },
    saveNewRow() {
      this.openDialog = false;
      this.$emit("newrow", cloneDeep(this.newrow));
    },
    dismissDialog() {
      this.openDialog = false;
    },
    _change(row, col, text) {
      let cval = get(row.item, col.value);
      this.$log.debug(
        `row ${row.index} column ${col.value} changed from ${cval} to ${text}`,
        cval,
        text
      );
      this.dynarefresh = false;
      Vue.set(row.item, col.value, text);
      let val = cloneDeep(row.item);
      this.$nextTick(() => {
        Vue.set(row.item, col.value, cval);
        this.dynarefresh = true;
      });
      this.editing = undefined;
      this.$emit("change", val, col, text);
    },
    _blur() {
      this.editing = undefined;
    },
    ctype(s) {
      switch (s) {
        case "TEXT":
          return TextInput;
        case "CHECKBOX":
          return CheckboxInput;
        case "FORMULA":
          return FormulaInput;
        case "LOOKUP":
          return LookupInput;
        case "DATE":
          return DateInput;
        case "ICON":
          return IconInput;
        case "SVG":
          return SVGInput;
        case "FLOAT":
          return FloatInput;
        case "COLOUR":
          return ColourInput;
        case "INTEGER":
          return IntegerInput;
      }
    }
  },
  mounted() {
    if (this.rows) Vue.$log.debug(`mounted: ${this.rows.length} rows`);
    else Vue.$log.debug("mounted: NO rows");
  }
};
</script>

<style scoped>
.autotable >>> .rowselect {
  width: 50px;
  max-width: 50px;
  min-width: 50px;
}
.autotable >>> .rowdelete {
  width: 50px;
  max-width: 50px;
  min-width: 50px;
}
.autotable >>> .v-input {
  font-size: 12px !important;
  padding-top: 0px !important;
}
.autotable >>> .v-list__tile__title {
  font-size: 12px !important;
}
.autotable >>> .v-input__slot {
  margin-bottom: 2px !important;
}
.autotable >>> .v-text-field input {
  padding-bottom: 1px !important;
  /*  padding-top: 1px !important;*/
}
.autotable >>> .v-datatable .v-input--selection-controls {
  padding-top: 13px !important;
}
.autotable >>> td {
  padding-left: 3px !important;
  padding-right: 3px !important;
  cursor: pointer;
}
.autotable >>> .readonly {
  cursor: auto !important;
}
.autotable >>> th {
  padding-left: 3px !important;
  padding-right: 3px !important;
}
.autotable >>> td:first-child {
  padding-left: 11px !important;
}
.autotable >>> th:first-child {
  padding-left: 11px !important;
}
.autotable >>> td:last-child {
  padding-right: 11px !important;
}
.autotable >>> th:last-child {
  padding-right: 11px !important;
}

.table-footer-prepend {
  margin-top: -58px;
  height: 58px;
}
.table-footer-prependsolo {
  position: relative;
  margin-top: 0px;
  height: 58px;
}
.addbuttonsolo {
  position: absolute;
  right: 2px !important;
  top: 5px !important;
}
</style>